import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateConsumerHealthAsset, privateConsumerHealthAssetsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

const PRIVATE_CONSUMER_HEALTH_ASSET_MODULE = 'privateConsumerHealthAsset';

const dataObjectModule = getDataObjectsModule<IPrivateConsumerHealthAsset>(privateConsumerHealthAssetsManager, 5);
const searchModule = getSearchModule();

const privateConsumerHealthAssetModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(PRIVATE_CONSUMER_HEALTH_ASSET_MODULE, privateConsumerHealthAssetModuleInstance);

export { PRIVATE_CONSUMER_HEALTH_ASSET_MODULE };
